<template>
  <div class="TopicsSearcher">
    <lm-label>Select Topics</lm-label>
    <div
      class="flex items-center justify-between py-4 border-b border-t bg-gray-100 -mx-6 px-6"
    >
      <span class="text-xs text-gray-700 uppercase font-mono">
        {{ total }} selected
      </span>
      <lm-search
        v-model="search"
        class="ml-auto"
        :placeholder="placeholder"
        @close="search = ''"
      />
    </div>
    <ul>
      <topics-searcher-item
        v-for="topic in filteredTopics"
        :key="topic._id"
        :topic="topic"
      />
    </ul>
  </div>
</template>

<script>
import LmLabel from '@/components/ui/LmLabel'
import LmSearch from '@/components/ui/LmSearch'
import {mapGetters} from 'vuex'
import {orderBy} from 'lodash'
import TopicsSearcherItem from '@/components/landscape/common/TopicsSearcherItem'

export default {
  name: 'TopicsSearcher',
  components: {
    LmLabel,
    LmSearch,
    TopicsSearcherItem
  },
  data() {
    return {
      search: '',
      placeholder: 'Search topic by title'
    }
  },
  computed: {
    ...mapGetters(['allTopics']),
    ...mapGetters({
      insightsTopics: 'insights/helpers/tempTopics',
      premisesTopics: 'premises/helpers/tempTopics'
    }),
    total() {
      const section = this.$route.name
      return section.includes('premise')
        ? this.premisesTopics.length
        : this.insightsTopics.length
      /* In Topics there is no option "New premise", only "New Insight" */
    },
    filteredTopics() {
      if (this.search === '') return this.sortTopics(this.allTopics)
      return this.sortTopics(
        this.allTopics.filter(topic =>
          topic.title.toLowerCase().includes(this.search.toLowerCase())
        )
      )
    }
  },
  methods: {
    sortTopics(topics) {
      return orderBy(
        topics,
        ['currentUser.favorited', 'createdAt'],
        ['desc', 'desc']
      )
    }
  }
}
</script>
